
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 98 98","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"4.5","y":"4.5","width":"89","height":"89","rx":"14.5","fill":"#4E1976"}}),_c('g',{attrs:{"clip-path":"url(#clip0_1690_237452)","fill":"#FCFCFC"}},[_c('path',{attrs:{"d":"M52.133 63.924h-6.266a.816.816 0 00-.7.4.8.8 0 000 .8l.55 1.117a3.333 3.333 0 002.95 1.85h.666a3.333 3.333 0 003-1.85l.55-1.117a.8.8 0 00-.75-1.2zM49 35.59a1.667 1.667 0 001.667-1.666v-4.166a1.667 1.667 0 00-3.334 0v4.166A1.667 1.667 0 0049 35.591zM64.317 34.441a1.666 1.666 0 00-2.35 0L59 37.391a1.666 1.666 0 001.183 2.85 1.667 1.667 0 001.167-.483l2.95-2.95a1.666 1.666 0 00.017-2.367zM69 49.758a1.667 1.667 0 00-1.667-1.667H64a1.667 1.667 0 000 3.333h3.333A1.667 1.667 0 0069 49.758zM39 37.39l-2.967-2.95a1.667 1.667 0 00-2.35 2.35l2.95 2.968c.31.307.73.481 1.167.483a1.667 1.667 0 001.2-2.85zM34 48.09h-3.333a1.666 1.666 0 100 3.334H34a1.666 1.666 0 100-3.333zM49 38.091a10.9 10.9 0 00-10.9 10.9 10.683 10.683 0 004.233 8.583.85.85 0 01.334.667v.75a2.449 2.449 0 002.483 2.433h7.7a2.433 2.433 0 002.433-2.4v-.65a.851.851 0 01.334-.716A10.884 10.884 0 0049 38.09zm4.317 17.1a3.216 3.216 0 00-1.367 2.617.266.266 0 01-.283.283h-5.334a.284.284 0 01-.283-.283 3.217 3.217 0 00-1.367-2.617 7.568 7.568 0 118.634 0z"}})]),_c('rect',{attrs:{"x":"4.5","y":"4.5","width":"89","height":"89","rx":"14.5","stroke":"#F0CDF4","stroke-width":"9"}}),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_1690_237452"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(29 28.09)","d":"M0 0h40v40H0z"}})])])])
          )
        }
      }
    